var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticStyle:{"height":"800px !important"},attrs:{"value":_vm.value,"width":"80%","scrollable":false},on:{"input":_vm.close}},[_c('v-card',[(_vm.isLoading && _vm.urlPreview)?_c('ProgressCircle',{staticClass:"py-6"}):_c('iframe',{attrs:{"src":_vm.urlPreview,"width":"100%","height":"700","frameBorder":"0"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }